var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSidePanelChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 61,
    viewBox: "0 0 91 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7082_300498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2102 8H2.95455C1.87508 8 1 8.87508 1 9.95455V49.0455C1 50.1249 1.87508 51 2.95455 51H67.2102C68.2897 51 69.1648 50.1249 69.1648 49.0455V9.95455C69.1648 8.87508 68.2897 8 67.2102 8Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5415 34.2288C31.7871 34.2288 31.9959 34.1364 32.2415 34.0037L39.4011 30.113C39.9107 29.8302 40.0888 29.6455 40.0888 29.3395C40.0888 29.0336 39.9107 28.8488 39.4011 28.5718L32.2415 24.6754C31.9959 24.5426 31.7871 24.4561 31.5415 24.4561C31.0871 24.4561 30.8047 24.7793 30.8047 25.2815V33.3976C30.8047 33.8997 31.0871 34.2288 31.5415 34.2288Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2422 8H73.0717C71.9923 8 71.1172 8.87508 71.1172 9.95455V49.0455C71.1172 50.1249 71.9923 51 73.0717 51H87.2422C88.3217 51 89.1967 50.1249 89.1967 49.0455V9.95455C89.1967 8.87508 88.3217 8 87.2422 8Z",
    fill: "#4F4C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2688 26.584H77.4734C76.9336 26.584 76.4961 27.0215 76.4961 27.5613V27.6794C76.4961 28.2191 76.9336 28.6567 77.4734 28.6567H86.2688C86.8086 28.6567 87.2461 28.2191 87.2461 27.6794V27.5613C87.2461 27.0215 86.8086 26.584 86.2688 26.584Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2617 30.6113H76.489C75.9493 30.6113 75.5117 31.0489 75.5117 31.5886V31.7068C75.5117 32.2465 75.9493 32.684 76.489 32.684H86.2617C86.8015 32.684 87.239 32.2465 87.239 31.7068V31.5886C87.239 31.0489 86.8015 30.6113 86.2617 30.6113Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2635 34.6387H74.0476C73.5079 34.6387 73.0703 35.0762 73.0703 35.6159V35.7341C73.0703 36.2738 73.5079 36.7114 74.0476 36.7114H86.2635C86.8032 36.7114 87.2408 36.2738 87.2408 35.7341V35.6159C87.2408 35.0762 86.8032 34.6387 86.2635 34.6387Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2667 38.666H80.4031C79.8633 38.666 79.4258 39.1036 79.4258 39.6433V40.1319C79.4258 40.6717 79.8633 41.1092 80.4031 41.1092H86.2667C86.8064 41.1092 87.244 40.6717 87.244 40.1319V39.6433C87.244 39.1036 86.8064 38.666 86.2667 38.666Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2699 43.0635H81.3835C80.8438 43.0635 80.4062 43.501 80.4062 44.0407C80.4062 44.5805 80.8438 45.018 81.3835 45.018H86.2699C86.8096 45.018 87.2472 44.5805 87.2472 44.0407C87.2472 43.501 86.8096 43.0635 86.2699 43.0635Z",
    id: "black-triangle",
    fill: "#312F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2628 46.9717H75.0241C74.4844 46.9717 74.0469 47.4092 74.0469 47.949V48.0671C74.0469 48.6068 74.4844 49.0444 75.0241 49.0444H86.2628C86.8025 49.0444 87.2401 48.6068 87.2401 48.0671V47.949C87.2401 47.4092 86.8025 46.9717 86.2628 46.9717Z",
    id: "black-triangle",
    fill: "#312F38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7082_300498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.4432,
    height: 43,
    fill: "white",
    transform: "translate(1 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidePanelChat);
export default __webpack_public_path__ + "static/media/icon-side-panel-chat.473bd23eabc6723ee2c12cb60d258364.svg";
export { ForwardRef as ReactComponent };